import { render, staticRenderFns } from "./OrganizationsList.vue?vue&type=template&id=35a4c32c"
import script from "./OrganizationsList.vue?vue&type=script&lang=js"
export * from "./OrganizationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a4c32c')) {
      api.createRecord('35a4c32c', component.options)
    } else {
      api.reload('35a4c32c', component.options)
    }
    module.hot.accept("./OrganizationsList.vue?vue&type=template&id=35a4c32c", function () {
      api.rerender('35a4c32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/OrganizationsList.vue"
export default component.exports